import * as Scenes from "oc-threejs/Scenes";
import { Pass } from "three/examples/jsm/postprocessing/Pass";

import { Object3D, WebGLRenderTarget, WebGLRenderer } from "three";

declare const STAGE: any;

/**
 * Erlaubt es, innerhalb der EffectComposer-Kette Objekte vorübergehend auszublenden
 */
export class VisibleSwitchRenderPass extends Pass {
  list: Object3D[] | null = null;
  predicate: (object: Object3D) => boolean;
  inverse: boolean;

  constructor(predicate: (object: Object3D) => boolean) {
    super();
    this.predicate = predicate;
    this.renderToScreen = true;
    this.clear = false;
    this.needsSwap = false;
    this.inverse = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(
    renderer: WebGLRenderer,
    writeBuffer: WebGLRenderTarget,
    readBuffer: WebGLRenderTarget,
    delta: number,
    maskActive: boolean,
  ): void {
    if (this.list === null) {
      this.list = Scenes.filter(STAGE.scene, (x: any) => x.visible && this.predicate(x));
      this.list!.forEach((x) => (x.visible = false));
    } else {
      this.list!.forEach((x) => (x.visible = true));
      this.list = null;
    }
  }
}
